export default {
  "contact.title": "Contact Us",
  "contact.subtitle": "We're here to help. Don't hesitate to reach out with any questions.",
  "contact.info": "Information",
  "contact.address": "Bonanjo, Douala, Cameroon",
  "contact.phone1": "+237 687 696 969",
  "contact.email": "contact@tennisclubdouala.com",
  "contact.hours": "Every day, 6 AM – 10 PM",
  "contact.social": "Social Media",
  "contact.form.title": "Send us a message",
  "contact.form.name": "Full Name",
  "contact.form.email": "Email",
  "contact.form.phone": "Phone",
  "contact.form.subject": "Subject",
  "contact.form.message": "Message",
  "contact.form.cta": "Send Message",
  "contact.form.success": "Message sent successfully! We will get back to you shortly.",
  "contact.form.error": "An error occurred. Please try again.",
  "contact.map": "Find Us"
}